// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications_notifications__PGkKY","all_notification":"Notifications_all_notification__4EYRc"};